import { render, staticRenderFns } from "./resetPassword.vue?vue&type=template&id=15a2c3c4&scoped=true&"
import script from "./resetPassword.vue?vue&type=script&lang=js&"
export * from "./resetPassword.vue?vue&type=script&lang=js&"
import style0 from "./resetPassword.vue?vue&type=style&index=0&lang=css&"
import style1 from "./resetPassword.vue?vue&type=style&index=1&id=15a2c3c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a2c3c4",
  null
  
)

export default component.exports